import noop from './noop';

const isNoop = (func) => func === noop;

export default isNoop;
